// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductBuyerHeader":"cy_a bhh_sp","ProductBuyerHeader__username":"cy_b bhh_vf"};